"use client";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

const SuperOfferModal = dynamic(() => import("./SuperOfferModal"), {
    ssr: false,
});

interface Props {
    companyId: string;
    domain: string;
    pageKey?: string;
}

const LazySuperOfferModal = (props: Props) => {
    const [canLoad, setCanLoad] = useState(false);

    useEffect(() => {
        let idleId: number | undefined;
        const timeoutId = window.setTimeout(() => setCanLoad(true), 2500);

        if ("requestIdleCallback" in window) {
            idleId = window.requestIdleCallback(() => setCanLoad(true), { timeout: 3500 });
        }

        return () => {
            window.clearTimeout(timeoutId);
            if (idleId !== undefined && "cancelIdleCallback" in window) {
                window.cancelIdleCallback(idleId);
            }
        };
    }, []);

    if (!canLoad) return null;

    return <SuperOfferModal {...props} />;
};

export default LazySuperOfferModal;
